import React from 'react'

import { Field } from 'formik'

import { formatPhone } from '../../utils/PhoneUtils'

const PhoneField = ({ name, ...props }) => {
  if (props.value !== undefined) {
    const displayValue = formatPhone(props.value)
    return (
      <input {...props} name={name} value={displayValue} type="tel" className={props.className || 'form-control'} />
    )
  }

  return (
    <Field name={name}>
      {({ field }) => {
        const displayValue = formatPhone(field.value)

        return (
          <input {...props} {...field} value={displayValue} type="tel" className={props.className || 'form-control'} />
        )
      }}
    </Field>
  )
}

export default PhoneField
